// eslint-disable-next-line
export const MODALS = {
  PATIENT_CREATE_SELECT_MODE: () => import('@/components/domains/patient/PatientCreateSelectModeModal.vue'),
  PATIENT_CREATE: () => import('@/components/domains/patient/PatientCreateModal.vue'),
  STORY_COVER_ADD_MODAL: () => import('@/components/domains/stories/StoryCoverAddModal.vue'),
  DOCTOR_SCHEDULE_INFO_MODAL: () => import('@/components/domains/doctors/DoctorScheduleInfoModal.vue'),
  INSURANCE_SUB_PROGRAM_DEACTIVATE_MODAL: () => import('@/components/domains/insurance/InsuranceSubProgramDeactivateModal.vue'),
};


